import React from "react";
import { useSelector } from "react-redux";
import { getGoalValue, getForecastValue } from "../../../../modules/goals/goalsModule";
import DonutForecast from "../../../global/donutForecast/donutForecastModule";

const LeastLikelyToSucceed = () => {
  const {
    title,
    locationName,
    currentValPacing,
    currentVal,
    prevPeriodVal,
    goalIncrease,
    currencySymbol,
    goalUsesPercent,
    goalValue
  } = useSelector((state) => state.goalsSummary.worstPerformingGoal);
  const { worstPerformingGoal, currentUser } = useSelector((state) => state.goalsSummary);
  return (
    <DonutForecast
      title="LEAST LIKELY TO SUCCEED"
      metricTitle={title}
      metricLocation={locationName}
      hidePercentChanged
      showForecast
      currentValPacing={currentValPacing}
      forecastValue={getForecastValue(worstPerformingGoal)}
      value={getGoalValue(worstPerformingGoal)}
      goalCurrentVal={currentVal}
      changeValue={0.03}
      goalRemainValue={prevPeriodVal * (goalIncrease / 100) + prevPeriodVal - currentVal}
      currencySymbol={currencySymbol}
      currentUser={currentUser}
      goalUsesPercent={goalUsesPercent}
      goalValue={goalValue}
    />
  );
};

export default LeastLikelyToSucceed;
